









import { Component, Prop, Vue } from 'vue-property-decorator';
import { SiteRole, siteAdminRoleApis } from '@/api';
import * as _ from 'lodash';

@Component
export default class RoleSelectM extends Vue {
  @Prop({ required: true }) value!: number;
  @Prop({ required: true }) siteId!: number;
  localValue: number | string = -1;
  debounceSearch!: (name: string) => void;
  roles: Array<SiteRole> = [];

  created() {
    this.debounceSearch = _.debounce(this.remoteSearch, 150);
    this.localValue = this.value;
    if (this.localValue > 0) {
      this.search(this.localValue);
    }
  }

  private search(search: string | number | null) {
    siteAdminRoleApis.getRoles(this.siteId, 0).then(roles => {
      this.roles = roles.filter(role => {
        return (
          !search ||
          role.name.includes(search.toString()) ||
          role.title.includes(search.toString()) ||
          role.id == search
        );
      });
    });
  }

  async remoteSearch(value: string) {
    this.search(value);
  }

  handleChoice(r: SiteRole) {
    this.localValue = r.title;
    this.$emit('input', r.id);
    this.roles = [];
  }
}
